import diacritic from 'diacritic-helper'
import Diacritics from 'diacritic'
import moment from 'moment'

import { i18n } from 'src/boot/i18n'

const { t } = i18n.global

/**
 *
 * @param {string} term: Le terme sur lequel se baser pour générer les keywords
 * @param {"eng" | "fr"} lang: Langue désiré
 * @returns {string[]} keywords: Tableau contenant les variations possibles du terme
 */
function _generateKeywords(term, lang = 'fr') {
  /** @const {Set<sring>} */
  const result = new Set([term])

  result.forEach((item) => {
    // NOTE: Iлｔèｒｎåｔïｏｎɑｌíƶａｔï߀ԉ -> Internationalization
    result.add(Diacritics.clean(item))
  })

  // NOTE: changer "'" en " "
  result.add(term.replace(/'/g, ' '))

  result.forEach((item) => {
    result.add(String(item).toLowerCase())
  })

  return [...result]
}

export function buildCriterias(term, notifications = []) {
  let pending = RegExp(diacritic('.*' + 'attente' + '.*'), 'gi')
  let ongoing = RegExp(diacritic('.*' + 'cour' + '.*'), 'gi')
  let done = RegExp(diacritic('.*' + 'traité' + '.*'), 'gi')
  let rejected = RegExp(diacritic('.*' + 'rejeté' + '.*'), 'gi')
  let canceled = RegExp(diacritic('.*' + 'annulé' + '.*'), 'gi')

  term = term.replace(pending, 'pending')
  term = term.replace(ongoing, 'ongoing')
  term = term.replace(done, 'done')
  term = term.replace(rejected, 'rejected')
  term = term.replace(canceled, 'canceled')
  term = term.replace(/[’´‘]/gi, "'")
  term = term.trim()

  let searchTerm = RegExp(diacritic('.*' + term + '.*'), 'gi')

  let criterias = {
    'meta.updatedAt': { $gt: 0 },
    $or: [
      { _id: { $regex: searchTerm } },
      { 'tracking.code': { $regex: searchTerm } },
      { 'author.firstName': { $regex: searchTerm } },
      { 'author.lastName': { $regex: searchTerm } },
      { 'content.message': { $regex: searchTerm } },
      { 'category.name': { $regex: searchTerm } },
      { 'category.parent.name': { $regex: searchTerm } },
      { 'location.agency.name': { $regex: searchTerm } },
      { 'location.place.name': { $regex: searchTerm } },
      { 'location.place.code': { $regex: searchTerm } },
      { 'location.residence.name': { $regex: searchTerm } },
      { 'location.spot.name': { $regex: searchTerm } },
      { 'location.spot.code': { $regex: searchTerm } },
      { 'meta.agency.name': { $regex: searchTerm } },
      { 'tracking.status': { $regex: searchTerm } }
    ]
  }

  const date = moment(term, ['DD/MM/YYYY', 'DD/MM', 'DD/MM/YY'], true)
  let dtstart = null
  let dtend = null
  if (date.isValid()) {
    dtstart = date.toISOString()
    dtend = date.add(1, 'day').toISOString()
  }

  if (dtstart !== null) {
    criterias.$or = [
      ...criterias.$or,
      {
        $and: [
          { 'meta.createdAt': { $gt: dtstart } },
          { 'meta.createdAt': { $lt: dtend } }
        ]
      }
    ]
  }

  // TODO: lire les termes depuis i18n
  const isRequestTenantKeywords = [
    ..._generateKeywords(t('createIssue.requestTenant')),
    ..._generateKeywords(t('createIssue.request')),
    ..._generateKeywords(t('createIssue.tenant'))
  ].includes(term)

  if (isRequestTenantKeywords) {
    criterias.$or = [...criterias.$or, { 'meta.isRequestTenant': true }]
  }

  // TODO: lire "Je m'en charge" depuis i18n
  const isPrivateKeywords = _generateKeywords(
    t('issueDetails.isPrivate')
  ).includes(term)
  if (isPrivateKeywords) {
    criterias.$or = [
      ...criterias.$or,
      {
        $and: [{ 'meta.isPrivate': true }]
      }
    ]
  }

  const isNotifKeywords =
    [
      ..._generateKeywords(t('notification.title')),
      ..._generateKeywords(t('notification.shortTitle'))
    ].includes(term) && notifications.length > 0
  if (isNotifKeywords) {
    criterias.$or = [
      {
        'meta.id': {
          $in: notifications.map((n) => n.id)
        }
      }
    ]
  }

  return criterias
}
